import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyAccount() {
  const dispatch = useAppDispatch()
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)

  useEffect(() => {
    dispatch(fetchLoyaltyAccount())
  }, [dispatch])

  return loyaltyAccount
}

export default useLoyaltyAccount
